/* Colour chart (sections/colour-chart.liquid).
   Reads the colours from <script type="application/json" data-cchart-json>:
   [{handle, url, colour, swatch, image, w, alt, image2, w2, alt2, variant_id, price, compare, available}]
   A swatch tap swaps the photo, name, price and links with no request for product data. The swatch links become a
   radio group (one tab stop, arrow keys move between colours). Add to basket uses Olilu.cart.add, then opens the basket. */
(function () {
  'use strict';

  var WIDTHS = [450, 700, 900, 1200, 1500];

  function sized(url, w) {
    if (/([?&])width=\d+/.test(url)) return url.replace(/([?&])width=\d+/, '$1width=' + w);
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function srcsetFor(url, max) {
    if (!url) return '';
    var list = WIDTHS.filter(function (w) { return !max || w <= max; });
    if (!list.length) list = [max];
    return list.map(function (w) { return sized(url, w) + ' ' + w + 'w'; }).join(', ');
  }

  function init(root) {
    var O = window.Olilu;
    var jsonEl = root.querySelector('[data-cchart-json]');
    if (!O || !jsonEl) return;
    var data;
    try { data = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    if (!data || !data.length) return;

    var q = function (sel) { return root.querySelector(sel); };
    var media = q('.cchart__media');
    var flat = q('.cchart__img--flat');
    var hand = q('.cchart__img--hand');
    var nameEl = q('[data-cchart-name]');
    var priceEl = q('[data-cchart-price]');
    var form = q('[data-cchart-form]');
    var idInput = q('[data-cchart-id]');
    var addBtn = q('[data-cchart-add]');
    var soldout = q('[data-cchart-soldout]');
    var notify = q('[data-cchart-notify]');
    var details = q('[data-cchart-details]');
    var reviews = q('[data-cchart-reviews]');
    var errorEl = q('[data-cchart-error]');
    var grid = q('[data-cchart-grid]');
    var swatches = O.$$('[data-cchart-swatch]', root);
    var sizes = (flat && flat.getAttribute('sizes')) || '(min-width: 990px) 56vw, 100vw';
    var current = Number(root.getAttribute('data-selected')) || 0;
    var warmed = {};

    function priceHtml(it) {
      if (it.compare > it.price) {
        return '<span class="price price--sale">' + O.money(it.price) + '</span><s class="price__was">' + O.money(it.compare) + '</s>';
      }
      return '<span class="price">' + O.money(it.price) + '</span>';
    }

    // Swap an <img> (or the placeholder SVG when the first colour had no photo) to a new photo
    function setImage(el, cls, url, max, alt) {
      if (!url) {
        if (el) el.hidden = true;
        return el;
      }
      if (!el || el.tagName !== 'IMG') {
        var img = document.createElement('img');
        img.className = 'cchart__img ' + cls;
        img.loading = 'lazy';
        img.setAttribute('sizes', sizes);
        if (el && el.parentNode) el.parentNode.replaceChild(img, el);
        else if (media) media.appendChild(img);
        el = img;
      }
      el.hidden = false;
      el.removeAttribute('style'); // the server-rendered focal point belongs to the previous photo
      el.setAttribute('srcset', srcsetFor(url, max));
      el.setAttribute('src', url);
      el.setAttribute('alt', alt || '');
      return el;
    }

    // Start fetching a colour's photo as soon as a pointer or focus reaches its swatch
    function warm(i) {
      var it = data[i];
      if (!it || warmed[i] || !it.image) return;
      warmed[i] = true;
      var im = new Image();
      im.sizes = sizes;
      im.srcset = srcsetFor(it.image, it.w);
      im.src = it.image;
    }

    function markSwatches() {
      swatches.forEach(function (a) {
        var on = Number(a.getAttribute('data-index')) === current;
        a.setAttribute('aria-checked', on ? 'true' : 'false');
        a.setAttribute('tabindex', on ? '0' : '-1');
      });
    }

    function select(i) {
      var it = data[i];
      if (!it) return;
      current = i;
      markSwatches();

      if (nameEl) nameEl.textContent = it.colour;
      if (priceEl) priceEl.innerHTML = priceHtml(it);

      flat = setImage(flat, 'cchart__img--flat', it.image, it.w, it.alt);
      if (it.image2) {
        hand = setImage(hand, 'cchart__img--hand', it.image2, it.w2, it.alt2);
        if (media) media.classList.add('has-hand');
      } else {
        if (hand) hand.hidden = true;
        if (media) media.classList.remove('has-hand');
      }

      if (media) media.setAttribute('href', it.url);
      if (details) details.setAttribute('href', it.url);
      if (notify) notify.setAttribute('href', it.url);
      if (reviews) reviews.setAttribute('href', it.url + '#reviews');

      if (idInput) idInput.value = it.variant_id;
      if (addBtn) addBtn.textContent = 'Add to basket · ' + O.money(it.price);
      if (form) form.hidden = !it.available;
      if (soldout) soldout.hidden = !!it.available;
      if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }
    }

    // Progressive enhancement: the swatch links become a radio group
    if (grid) grid.setAttribute('role', 'radiogroup');
    swatches.forEach(function (a) {
      var i = Number(a.getAttribute('data-index'));
      a.setAttribute('role', 'radio');
      a.removeAttribute('aria-current');
      a.addEventListener('click', function (e) {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button > 0) return;
        e.preventDefault();
        select(i);
      });
      a.addEventListener('keydown', function (e) {
        var k = e.key;
        if (k === ' ' || k === 'Spacebar') { e.preventDefault(); select(i); return; }
        var to = null;
        if (k === 'ArrowRight' || k === 'ArrowDown') to = i + 1;
        else if (k === 'ArrowLeft' || k === 'ArrowUp') to = i - 1;
        else if (k === 'Home') to = 0;
        else if (k === 'End') to = swatches.length - 1;
        if (to === null) return;
        e.preventDefault();
        to = (to + swatches.length) % swatches.length;
        select(to);
        var next = swatches[to];
        if (next) { next.focus(); warm(to + 1); }
      });
      ['pointerenter', 'focus', 'touchstart'].forEach(function (ev) {
        a.addEventListener(ev, function () { warm(i); }, { passive: true });
      });
    });
    markSwatches();

    // Phones: bring the preselected swatch into the sideways-scrolling grid without moving the page
    var cur = swatches[current];
    if (grid && cur && grid.scrollWidth > grid.clientWidth) {
      var left = cur.offsetLeft - (grid.clientWidth - cur.offsetWidth) / 2; // the grid is position: relative
      grid.scrollLeft = Math.max(0, left);
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        if (!O.cart || !O.basket) return; // no helpers: let the form post to /cart/add
        e.preventDefault();
        var it = data[current];
        if (!it || !it.available || (addBtn && addBtn.classList.contains('is-loading'))) return;
        if (addBtn) { addBtn.classList.add('is-loading'); addBtn.setAttribute('aria-busy', 'true'); }
        if (errorEl) errorEl.hidden = true;
        O.cart.add([{ id: it.variant_id, quantity: 1 }])
          .then(function () { O.basket.open(addBtn); })
          .catch(function (err) {
            if (!errorEl) return;
            var msg = (err && err.message) || '';
            errorEl.textContent = msg
              ? msg.replace(/\bcart\b/gi, 'basket')
              : 'Sorry, we could not add that to your basket. Please try again.';
            errorEl.hidden = false;
          })
          .then(function () {
            if (addBtn) { addBtn.classList.remove('is-loading'); addBtn.removeAttribute('aria-busy'); }
          });
      });
    }
  }

  function boot() {
    if (window.Olilu && window.Olilu.ready) window.Olilu.ready('[data-cchart]', init);
  }
  if (window.Olilu && window.Olilu.ready) boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
